import './RadioButtonGroup.scss';

interface RadioButtonGroupProps {
  children: React.ReactNode;
}

export default function RadioButtonGroup({ children }: RadioButtonGroupProps) {
  return <div className='radio-button-group'>{children}</div>;
}
